import React, { useState, useEffect } from "react";
import { Row, Col, Button, Dropdown, ButtonGroup, Form, Modal } from "react-bootstrap";
import { TfiAnnouncement } from "react-icons/tfi";
import { TbEyeStar } from "react-icons/tb";

import axios from "axios";
import moment from "moment"; // For date formatting
import "./dept-announcement.css";
const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (isNaN(date)) return 'Invalid Date';

  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};

// Modal Component
function ResponsiveModal({ show, onHide, announcement }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{announcement?.title || "Announcement"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {announcement && (
          <>
            <h5>{announcement.title}</h5>
            <p><strong>Message:</strong> {announcement.message}</p>
            <p><strong>Author:</strong> {announcement.author || "Admin"}</p>
            <p><strong>Date:</strong> {formatDateTime(announcement.createdAt)}</p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: "#ddd" }}>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function DeptAnnouncement() {
  const rowsPerPage = 10;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const userDepartment = localStorage.getItem("department");

  useEffect(() => {
    const fetchAnnouncements = async () => {
      if (!userDepartment) {
        console.error("User department not found in session storage.");
        return;
      }

      try {
        const response = await axios.get(
          "https://backend.ems.hiradentallab.com/api/deptannouncements/by-department",
          {
            params: { department: userDepartment },
          }
        );
        setData(response.data);
        setFilteredData(response.data);
        setTotalPages(Math.ceil(response.data.length / rowsPerPage));
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, [userDepartment]);

  const handleSearch = (e) => {
    e.preventDefault();
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = data.filter((item) => {
      const title = item.title ? item.title.toLowerCase() : "";
      const message = item.message ? item.message.toLowerCase() : "";
      const date = item.createdAt
        ? moment(item.createdAt).format("MMM Do YYYY").toLowerCase()
        : "";

      return (
        title.includes(query) || message.includes(query) || date.includes(query)
      );
    });

    setFilteredData(filtered);
    setTotalPages(Math.ceil(filtered.length / rowsPerPage));
    setCurrentPage(1);
  };

  const handleClickOpen = (announcement) => {
    setSelectedAnnouncement(announcement);
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const range = [];
    for (let i = 1; i <= totalPages; i++) {
      range.push(i);
    }
    return range;
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div>
    <div style={{padding:'10px'}}>
      <h1 className="announcement-header">
        <TfiAnnouncement style={{ marginRight: "2px", color: "#6c757d" }} />
        Announcement
      </h1>
      <hr />

      <div className="announcement-table-container">
        <div className="available-leaves-actions">
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-3">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle
                  split
                  variant="primary"
                  id="dropdown-split-basic"
                />
                <Dropdown.Menu>
                  <Dropdown.Item>10</Dropdown.Item>
                  <Dropdown.Item>25</Dropdown.Item>
                  <Dropdown.Item>50</Dropdown.Item>
                  <Dropdown.Item>100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end">
              <Form onSubmit={handleSearch}>
                <Form.Control
                  type="search"
                  placeholder="Search...."
                  value={searchQuery}
                  onChange={handleSearch}
                  className="search-bar"
                />
              </Form>
            </Col>
          </Row>
        </div>

        <div className="table-responsive">
          <table className="announcement-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Message</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item) => (
                  <tr key={item._id}>
                    <td>{item.title}</td>
                    <td>{item.message}</td>
                    <td>
                      {moment(item.createdAt).format("MMM Do YYYY, h:mm:ss a")}
                    </td>
                    <td>
                      <Button
                        onClick={() => handleClickOpen(item)}
                        size="sm"
                        variant="primary"
                      >
                        <TbEyeStar />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No data available</td>
                </tr>
              )}
            </tbody>
            <tfoot className="table-footer">
              <tr className="announcement-table-footer">
                <td>Total</td>
                <td>{data.length}</td>
                <td>-</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

    <div className="pagination-container">
                <Row className="custom-row">
                  <Col xs={12} md={9} className="custom-col-left">
                    Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, data.length)} of {data.length} entries
                  </Col>
                  <Col xs={12} md={3} className="custom-col-right" style={{marginTop:'10px'}}>
                    <nav>
                      <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Previous</button>
                        </li>
                        {pageRange().map((pageNumber) => (
                          <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => handlePageChange(pageNumber)}>{pageNumber}</button>
                          </li>
                        ))}
                        <li className={`page-item ${currentPage === Math.ceil(data.length / rowsPerPage) ? 'disabled' : ''}`}>
                          <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Next</button>
                        </li>
                      </ul>
                    </nav>
                  </Col>
                </Row>
              </div>
            </div>

            <ResponsiveModal show={dialogOpen} onHide={handleClose} announcement={selectedAnnouncement} />

    </div>
    </div>
  );
}
